/**
 * @file      /src/schedmsg/schedmsg-node.js
 * @author    Ryan Rossiter, ryan@kingsds.network
 * @date      March 2020
 *
 * This is the SchedMsg implementation for commands that are node-specific
 * or have node-specific behaviour.
 */


const DCP_ENV = require('dcp/common/dcp-env');
const { requireNative } = require('dcp/dcp-client/webpack-native-bridge');
if (DCP_ENV.platform === 'nodejs') {
  process = requireNative('process');
}

const { SchedMsg } = require('./schedmsg');

class SchedMsgNode extends SchedMsg {
  constructor(worker) {
    super(worker);

    this.registerHandler('announce', this.onAnnouncement.bind(this));
    this.registerHandler('reload', this.onReload.bind(this));
  }

  onAnnouncement({ message }) {
    console.log('\u{1f4ac} Broadcast message:', message);
  }

  onReload() {
      console.log('Scheduler reload command, exiting worker...');
      process.exit(13);   // Exit code 0x0C = 13 = exit due to reload command
  }

  onKill(opts) {
    super.onKill(opts);

    process.exit(130);
  }
}

Object.assign(module.exports, {
  SchedMsgNode
});
